/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Available accessories
 */
export enum AccessoryType {
  MAGNET_3_PACK = 'MAGNET_3_PACK',
  MAGNET_9_PACK = 'MAGNET_9_PACK',
  MAGNET_3D = 'MAGNET_3D',
  AMBIENT_LIGHT = 'AMBIENT_LIGHT',
  HD_MOUNTING_SYSTEM = 'HD_MOUNTING_SYSTEM',
  STAND = 'STAND',
}
